export class Cid {
  diagnosticDate: Date | null;
  cidCatId: string;
  cidCatCode: string;
  cidCatDescription: string;
  cidSubCatId: string;
  cidSubCatCode: string;
  cidSubCatDescription: string;
  systemId: string;
  systemDescription: string;
  specificationId: string;
  specificationDescription: string;
  topographyId: string;
  topographyDescription: string;
  canStageCid: boolean | null;

  constructor() {
    this.diagnosticDate = null;
    this.canStageCid = null;
    this.cidCatId = '';
    this.cidCatCode = '';
    this.cidCatDescription = '';

    this.cidSubCatId = '';
    this.cidSubCatCode = '';
    this.cidSubCatDescription = '';

    this.systemId = '';
    this.systemDescription = '';

    this.specificationId = '';
    this.specificationDescription = '';

    this.topographyId = '';
    this.topographyDescription = '';
  }
}

export function isCidIncomplete(cid: Cid): boolean {
  if (!cid) return true;

  const fields: (string | number)[] = [cid.cidCatId, cid.cidSubCatId, cid.systemId, cid.specificationId, cid.topographyId];
  const hasEmptyField = fields.some(value => value === null || value === undefined || value === '');
  const allZero = fields.every(value => value === '0' || value === 0);

  return hasEmptyField || allZero;
}

export class CidResult {

  codigo: string;
  hematologico: boolean;
  id: string;
  nome: string;
  oncologico: boolean;
  stagingType: "" | "hematological" | "oncological" | "lymphoma" | "noOncological" | "error" | "oncologico" | undefined;

  constructor() {
    this.codigo = '';
    this.hematologico = false;
    this.id = '';
    this.nome = '';
    this.oncologico = false;
    this.stagingType = '';
  }
}

export class GenericResult {
  id: string;
  nome: string;

  constructor() {
    this.id = '';
    this.nome = '';
  }
}

export class CodDesc {
  cod: string;
  descr: string;

  constructor() {
    this.cod = '';
    this.descr = '';
  }
}

export class CidSelected {
  cid: CodDesc;
  cid10: CodDesc[];

  constructor() {
    this.cid = new CodDesc();
    this.cid10 = [];
  }
}

export class SystemSelected {
  system: string;
  classifications: ClassificationSelected[];

  constructor() {
    this.system = '';
    this.classifications = [];
  }
}

export class ClassificationSelected {
  cod: string;
  description: string;
  diseaseClassificationType: string;

  constructor() {
    this.cod = '';
    this.description = '';
    this.diseaseClassificationType = '';
  }
}

export class SelectedCid {
  search: string;
  filter: string;
  cid: string;
  cid10: string;
  system: string;
  classification: string;

  constructor() {
    this.search = '';
    this.filter = '';
    this.cid = '';
    this.cid10 = '';
    this.system = '';
    this.classification = '';
  }
}

